import { useTranslation } from 'react-i18next';

import { AuthLayout } from '../../app/layouts/AuthLayout.js';
import { PageHeader } from '../../ui/components/PageHeader.js';
import '../sign-in/sign-in.css';

/** How WeChat's callback ended (the API's redirect says). */
const RESULTS = [
  'connected',
  'not_following',
  'denied',
  'expired',
  'already_connected_elsewhere',
  'provider_error',
] as const;

type Result = (typeof RESULTS)[number];

const resultOf = (): Result => {
  const value = new URLSearchParams(window.location.search).get('result');
  return (RESULTS as readonly string[]).includes(value ?? '')
    ? (value as Result)
    : 'provider_error';
};

/**
 * After "Connect WeChat" (`/connected/wechat?result=…`, PROJECT.md H6.2):
 * shown in WeChat's own browser, which has no Gradex session, so it only
 * says how it went and to carry on where they started (the page there
 * updates by itself). Public and plain, like the other sign-in pages.
 */
export function WeChatDonePage() {
  const { t } = useTranslation();
  const result = resultOf();
  const good = result === 'connected' || result === 'not_following';
  return (
    <AuthLayout>
      <div className="sign-in">
        <PageHeader title={t('wechatDone.title')} />
        <div className="sign-in__form" role={good ? 'status' : 'alert'}>
          <p>{t(`wechatDone.${result}`)}</p>
          <p>{t(good ? 'wechatDone.back' : 'wechatDone.again')}</p>
        </div>
      </div>
    </AuthLayout>
  );
}
